// Wives: one Synty geisha strolls around the homestead for every ACTIVE marriage — those on the profile, and each REAL wife a husband has married
// through the Registry (server marriages, game/inviteManager.js). Real state only — no marriage, no wife. They keep to the village around the home tile.

import * as THREE from 'three'
import gsap from 'gsap'
import { Events, on } from '../ui/eventBus.js'
import { activeMarriages } from '../game/marriageManager.js'
import { getInvites } from '../game/inviteManager.js'
import { getHomeTileIndex, tileToWorld } from '../game/plotState.js'
import { GROUND_Y } from './hexGrid.js'
import { isBlocked } from './collision.js'
import { createSyntyChar, syntyCharsReady, scaleOf } from './syntyChars.js'
import { groundLift } from './paddyRows.js'

const MAX_VISIBLE = 4
const STROLL_RADIUS = 2.2 // world units around the home tile
let sceneRef = null
const wives = []

export function createWives({ scene }) {
  sceneRef = scene
  const resync = () => sync()
  on(Events.MarriageAccepted, resync)
  on(Events.MarriageDivorced, resync)
  on(Events.KingdomChange, resync)
  on(Events.AccountStatePulled, resync)
  on(Events.InvitesChange, resync) // (a real marriage began or ended)
  setTimeout(resync, 2000) // after the field and home tile exist
}

function sync() {
  if (!sceneRef || !syntyCharsReady()) return
  let want = 0
  try { want = Math.min(MAX_VISIBLE, activeMarriages().length + (getInvites().marriages?.wives?.length ?? 0)) } catch { want = 0 }
  while (wives.length < want) {
    const w = createSyntyChar('geisha')
    if (!w) break
    const home = homeXZ()
    w.position.set(home.x, GROUND_Y, home.z + 0.6)
    w.scale.setScalar(scaleOf(w))
    sceneRef.add(w)
    wives.push(w)
    stroll(w)
  }
  while (wives.length > want) {
    const w = wives.pop()
    gsap.killTweensOf(w.position); gsap.killTweensOf(w)
    sceneRef.remove(w)
  }
}

// Called every frame from the main loop: keep wives on top of any rice row they stroll across.
export function tickWives() {
  for (const w of wives) w.position.y += (GROUND_Y + groundLift(w.position.x, w.position.z) - w.position.y) * 0.35
}

function homeXZ() {
  const hk = getHomeTileIndex()
  return hk ? tileToWorld(hk) : { x: 0, z: 0 }
}

function stroll(w) {
  if (!w.parent) return
  const home = homeXZ()
  let x = w.position.x, z = w.position.z
  for (let i = 0; i < 12; i++) {
    const a = Math.random() * Math.PI * 2, r = 0.6 + Math.random() * (STROLL_RADIUS - 0.6)
    const nx = home.x + Math.cos(a) * r, nz = home.z + Math.sin(a) * r
    if (!isBlocked(nx, nz)) { x = nx; z = nz; break }
  }
  const dx = x - w.position.x, dz = z - w.position.z
  const dist = Math.hypot(dx, dz)
  w.rotation.y = Math.atan2(dx, dz)
  gsap.to(w.position, {
    x, z, duration: Math.max(1.5, dist * 1.6), ease: 'none',
    onComplete: () => { gsap.delayedCall(2 + Math.random() * 4, () => stroll(w)) }, // pause, then wander on
  })
}
